import {
    FrontSide,
    Mesh,
    MeshBasicMaterial,
    Object3D,
    RepeatWrapping,
    SRGBColorSpace,
} from 'three'
import { useEffect, useMemo } from 'react'
import { textureAsset } from '@/src/game/assetStore'
import { useTexture } from '@react-three/drei'

export function useAtlasMaterial() {
    const texture = useTexture(textureAsset.Atlas)
    useEffect(() => {
        texture.colorSpace = SRGBColorSpace
        texture.flipY = false
        texture.wrapS = RepeatWrapping
        texture.wrapT = RepeatWrapping
        texture.needsUpdate = true
    }, [texture])

    const atlasMaterial = useMemo(
        () =>
            new MeshBasicMaterial({
                color: '#ffffff',
                transparent: false,
                toneMapped: false,
                side: FrontSide,
                map: texture,
            }),
        [texture],
    )

    useEffect(() => {
        return () => {
            atlasMaterial.dispose()
        }
    }, [atlasMaterial])

    return atlasMaterial
}

export function applyMaterial<T extends Object3D>(
    asset: T,
    material: MeshBasicMaterial,
) {
    asset.traverse((child) => {
        if (!(child instanceof Mesh)) {
            return
        }
        child.material = material
    })
    return asset
}
